import { apiEndpointBase } from "./endpoint.config";

const base = apiEndpointBase;

export default {
  addCustomPoints: (communityId, userId) =>
    `${base}leaderboard/community/` +
    `${communityId}/user/${userId}/add-custom-point`,
};
